<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="copyrightPage">
<p class="copyrightText">Published by<br/>Grub Street<br/>4 Rainham Close<br/>London<br/>SW11 6SS</p>
<p class="copyrightText1">Copyright © Grub Street 2009</p>
<p class="copyrightText2">Copyright text © Tony Blackman</p>
<p class="copyrightText2">Copyright introduction © HRH The Duke of Edinburgh</p>
<p class="copyrightText1">First published in hardback 2007</p>
<p class="copyrightText2">This edition first published 2009</p>
<p class="copyrightText1"><span class="bold">British Library Cataloguing in Publication Data</span></p>
<p class="copyrightText3">Blackman, Tony</p>
<p class="copyrightText3">Vulcan test pilot: my experiences in the cockpit of a Cold War icon</p>
<p class="copyrightText3">1. Blackman, Tony 2. Vulcan (Jet bomber)</p>
<p class="copyrightText3">I. Title</p>
<p class="copyrightText3">623.7’463’0941</p>
<p class="copyrightText1"><span class="bold">ISBN-13: 9781906502300</span></p>
<p class="copyrightText1"><span class="bold">eISBN: 978-1-908117-95-3</span></p>
<p class="copyrightText1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the copyright owner.</p>
<p class="copyrightText1">Cover design by Lizzie B design</p>
<p class="copyrightText1">Typeset by Pearl Graphics, Hemel Hempstead</p>
<p class="copyrightText1">Printed and bound by MPG Ltd, Bodmin, Cornwall</p>
<p class="copyrightText1">Grub Street Publishing only uses</p>
<p class="copyrightText2">FSC (Forest Stewardship Council) paper for its books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VulcanTestPilot_copyright.vue?42aa43be